import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import "../../../Assets/css/mjstatic.css";
import Button from "@mui/material/Button";
import StoreImage1 from "../../../Assets/images/static/MJ-1.webp";
import { Helmet } from "react-helmet";
import aboutimg from "../../../Assets/images/static/demo/img-about2.jpg";
import { useSelector } from "react-redux";
import { client_name } from "../../../Helpers/request";
import { useState, useEffect } from "react";
const OurStory = () => {

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        <Container>

                <Row>
            <Col className="rcs_breadcrumb m-0 mb-md-5">
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Typography color="text.primary">About Us</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
          <Row className="m-auto w-100">
            <div className="rcs_story_content">
              <h2>Discover the Alicia's Jewelers Difference</h2>
              <p>
                Welcome to Alicia's Jewelers, where your journey to finding the perfect diamond is guided by experienced professionals who are dedicated to providing you with the highest quality diamonds for your forever ring.
              </p>
            </div>
            <div className="rcs_story_content mt-5">
              <h2>Why Choose Alicia's Jewelers Over Online Options?</h2>
            </div>
          </Row>

          <div className="rcs_story_content  mb-5">
            <Row className="m-auto w-100">
              <Col md={7} xs={12} className="p-0">
                {/* <h2>Why Choose Alicia's Jewelers Over Online Options?</h2> */}
                <div className="our_story_list_box">
                  <ul>
                    <li> Personalized, In-Person Guidance: At Alicia's Jewelers, we understand that choosing the right diamond is a significant decision. Our team of experts is here to personally assist you every step of the way, ensuring that you make an informed choice that matches your preferences and budget.</li>
                    <li> Premium Diamonds Only: We take pride in offering only the finest, premium diamonds. Our selection is carefully curated to ensure that you receive nothing but the best, eliminating the guesswork often associated with online purchases.</li>
                    <li> Transparency and Honesty: Unlike some online jewelers, we prioritize your satisfaction over profits. We do not compromise on quality and do not include subpar stones in our collection to maximize our earnings. Your forever ring deserves the best.</li>
                    <li> Competitive Pricing: Our prices are competitive with those of online jewelers, ensuring that you get exceptional value for your investment while benefiting from the expertise and personal touch that only a brick-and-mortar store like Alicia's Jewelers can provide.</li>
                    <li> Experience Matters: Becoming a true diamond expert takes more than online research. Diamond connoisseurs know the importance of inspecting stones in person to fully appreciate their quality and brilliance. Trust us to guide you toward the perfect diamond.</li>
                  </ul>
                </div>

              </Col>
              <Col md={5} xs={12} className="rcs_our_story_img_main_outer_col">
                <div className="rcs_our_story_img_main">
                  <Image src={aboutimg} alt="about us image"></Image>
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="rcs_story_content">
                  <p>
                    Don't be swayed by the illusion of online expertise. The difference between an ordinary diamond and an extraordinary one can only be truly understood through personal inspection.
                  </p>
                  <p>At Alicia's Jewelers, our family is committed to ensuring that your family makes the best decision when choosing a forever ring. Experience the difference that our personalized service, premium diamonds, and competitive prices can make.</p>
                  <p>Visit Alicia's Jewelers today and embark on a journey to find the diamond of your dreams.</p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default OurStory;
